import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'metismenu/dist/metisMenu.css';
import 'sweetalert/dist/sweetalert.css';
import './animate.css';
import './style.css';
import './custom.css';



// WEBPACK FOOTER //
// ./styles/styles.js